import React from 'react'
import styled from 'styled-components'
import { Body1 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import SectionContainer from 'stories/V1/layouts/SectionContainer'
import Stack from 'components/elements/Stack'
import BenedictImage from 'assets/careers/founders/benedict.webp'
import LucasImage from 'assets/careers/founders/lucas.webp'
import GregorImage from 'assets/careers/founders/gregor.webp'
import YannikImage from 'assets/careers/founders/yannik.webp'
import Image from 'next/image'

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding: 0 10%;
    & > p {
        width: 70%;
        font-weight: 450;
        font-size: 17px;
        line-height: 24px;
        letter-spacing: 0.3px;
        @media (max-width: 860px) {
            width: 100%;
            font-size: 14px;
            line-height: 20px;
            letter-spacing: 0.4px;
        }
    }
`

const FoundersGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 260px);
    justify-content: center;
    gap: 8px;
    width: 100%;

    @media (max-width: 860px) {
        grid-template-columns: repeat(2, 160px);
    }
`

const FounderCard = styled.div`
    background: #3a1d6d;
    border-radius: 16px;
    overflow: hidden;
    padding: 12px;
    transition: transform 0.3s ease;
    width: 260px;
    @media (max-width: 860px) {
        width: 160px;
        padding: 8px;
    }

    .founder-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 3px;
        padding: 12.5px 0 5px 0;
    }

    .founder-image {
        display: flex;
        justify-content: center;
        height: 236px;
        img {
            border-radius: 12px;
        }
        position: relative;

        @media (max-width: 860px) {
            height: 144px;
            img {
                height: 144px;
                width: 144px;
            }
        }
    }

    .title {
        white-space: nowrap;
        font-family: var(--font-inter);
        font-weight: 650;
        font-size: 23px;
        line-height: 28px;
        letter-spacing: -0.2px;
        @media (max-width: 860px) {
            font-size: 17px;
            line-height: 20px;
            letter-spacing: 0.3px;
        }
    }

    .subtitle {
        font-family: var(--font-inter);
        font-weight: 650;
        font-size: 20px;
        line-height: 24px;
        letter-spacing: 0px;
        @media (max-width: 860px) {
            font-size: 14px;
            line-height: 20px;
            letter-spacing: 0.4px;
        }
    }

    &:hover {
        transform: translateY(-5px);
    }
`

const CareersFounders = () => {
    const founders = [
        {
            name: 'Benedict Kurz',
            title: 'CEO',
            image: BenedictImage,
        },
        {
            name: 'Lucas Hild',
            title: 'CTO',
            image: LucasImage,
        },
        {
            name: 'Gregor Weber',
            title: 'CPO',
            image: GregorImage,
        },
        {
            name: 'Yannik Prigl',
            title: 'Head of Backend',
            image: YannikImage,
        },
    ]

    return (
        <SectionContainer
            title={'Meet our Founders'}
            backgroundColor={'#221140'}
            borderRadius="48px"
            mobileBorderRadius="32px"
        >
            <Stack gutter={50}>
                <TextContainer>
                    <Body1 color={theme.colors.grayScaleSecondary} textAlign="center" fontFamily="var(--font-inter)">
                        Our founders created this platform as students, not executives. Still in high school, they saw how
                        disconnected education was from their digital lives. So they built the AI learning tool they always
                        wanted for themselves.
                    </Body1>

                    <Body1 color={theme.colors.grayScaleSecondary} textAlign="center" fontFamily="var(--font-inter)">
                        {`They skipped university and turned down sports careers to turn their school project into something
                        bigger—a mission to change how people learn worldwide. Today, they're still leading the way, democratizing personalised education for millions of students worldwide.`}
                    </Body1>
                </TextContainer>

                <FoundersGrid>
                    {founders.map((founder, index) => (
                        <FounderCard key={index}>
                            <div className="founder-image">
                                <Image src={founder.image} alt={founder.name} width={236} height={236} />
                            </div>
                            <div className="founder-info">
                                <Body1 color={theme.colors.white} fontFamily="var(--font-inter)" className="title">
                                    {founder.name}
                                </Body1>
                                <Body1
                                    color={theme.colors.grayScaleSecondary}
                                    fontFamily="var(--font-inter)"
                                    className="subtitle"
                                >
                                    {founder.title}
                                </Body1>
                            </div>
                        </FounderCard>
                    ))}
                </FoundersGrid>
            </Stack>
        </SectionContainer>
    )
}

export default CareersFounders
